import type { ApiResource } from '../schema';

export const resource: ApiResource = {
  id: 'notifications',
  slug: 'notifications',
  name: 'Notifications',
  description: 'Alert fan-out to Slack, Teams, Discord, and SMS. The same settings that power the alert paging described on the Phone System wiki page.',
  icon: 'NotificationsActive',
  endpoints: [
    {
      slug: 'get-chatops-settings',
      method: 'GET',
      path: '/api/settings/chatops',
      summary: 'Get notification settings',
      description: 'Returns the configured Slack/Teams/Discord webhook URLs and SMS (Twilio) settings for alert fan-out. Never echoes the Twilio auth token, only whether one is set.',
      auth: 'session',
      responseExample: `{
  "enabled": true,
  "minSeverity": "high",
  "slackUrl": "https://hooks.slack.com/services/...",
  "teamsUrl": "",
  "discordUrl": "",
  "sms": { "enabled": true, "provider": "twilio", "sid": "AC...", "from": "+15551234567", "to": "+15557654321", "hasToken": true }
}`,
      sourceFile: 'routes/chatops.js',
    },
    {
      slug: 'update-chatops-settings',
      method: 'PUT',
      path: '/api/settings/chatops',
      summary: 'Update notification settings',
      description: 'Sets webhook URLs and SMS configuration. Every send is best-effort — a bad webhook or missing SMS credentials never blocks the alert that triggered it from being created.',
      auth: 'session',
      requestBodyExample: `{ "enabled": true, "minSeverity": "high", "slackUrl": "https://hooks.slack.com/services/..." }`,
      responseExample: `{ "ok": true }`,
      sourceFile: 'routes/chatops.js',
    },
  ],
};
